import { CustomTooltip as Tooltip, CustomTooltipInfoIcon } from './tooltip';

const CustomTooltip = {
    Root: Tooltip,
    InfoIcon: CustomTooltipInfoIcon,
};

export default CustomTooltip;
